import React, { useState } from 'react';
import { change, FieldArray } from 'redux-form';
import classNames from 'classnames';
import { useDispatch } from 'react-redux';
import styles from './assets/program-array-fields.module.scss';
import RenderDomainArray from './RenderDomainArray';
import { DndProvider } from './dnd/DndRegistry';

const RenderFieldArray = (props: any) => {
    const { fields, isHiddenShow } = props;
    return (
        <DndProvider>
            <ul className={classNames(styles.ul, styles.sectionWrap)}>
                {fields.map((member: any, index: number, array: any) => (
                    <RenderSubFields
                        key={`i-${index}`}
                        member={member}
                        fields={array}
                        isHiddenShow={isHiddenShow}
                        isLast={index + 1 === fields.length}
                        isNotFirst={!!index}
                        index={index}
                    />
                ))}
            </ul>
        </DndProvider>
    );
};
type Props = {
    member: any;
    index: number;
    fields: any;
    isLast: boolean;
    isNotFirst: boolean;
    isHiddenShow: string;
};

const RenderSubFields: React.FunctionComponent<Props> = ({
    member,
    isHiddenShow,
    index,
    fields,
    isLast,
    isNotFirst,
}) => {
    const dispatch = useDispatch();
    const [changeSt, setChanged] = useState(false);
    const row = fields.get(index);
    const deleteRow = () => {
        if (!row.id) {
            fields.remove(index);
            setChanged(!changeSt);
        } else {
            dispatch(change('program-book', `${member}.status`, 2));
            setChanged(!changeSt);
        }
    };

    const backRow = () => {
        dispatch(change('program-book', `${member}.status`, 1));
        setChanged(!changeSt);
    };
    const creditStyle = {
        display: 'none',
    };

    const isApplied: boolean = +row.status === 3;

    return (
        <li style={+row.status === 2 ? creditStyle : {}} className={classNames('w-100', styles.itemLi)} key={index}>
            <div className={classNames(styles.wrappedSectionFields)}>
                <h2> Section - {row.title}</h2>
            </div>
            <div>
                <FieldArray name={`${member}.values`} isHiddenShow={isHiddenShow} component={RenderDomainArray} />
            </div>
        </li>
    );
};
export default RenderFieldArray;
